module.exports = __webpack_public_path__ + "img/special-hand.ba214d09.svg";